import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button } from '@mui/material';
import cn from 'classnames';

import getNormalizeURL from '@utils/getNormalizeURL';

import { IViewProductPageButtonProps } from './ViewProductPageButton.interface';

import './style.scss';

const ViewProductPageButton: FC<IViewProductPageButtonProps> = ({
  linkToProductPage,
  className,
  target = '_blank',
}) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="text"
      href={getNormalizeURL(linkToProductPage)}
      target={target}
      className={cn('btn-link', className)}
      disabled={!linkToProductPage}
    >
      <OpenInNewIcon color={!linkToProductPage ? 'disabled' : 'success'} />
      <span className="btn-link__button_text">{t('adminInquiries.viewProductPage')}</span>
    </Button>
  );
};

export default ViewProductPageButton;
